import { Flex, FlexProps } from "@chakra-ui/react";
import React from "react";

import {
  CallSpeakerFragment,
  TranscriptSegmentFragment,
} from "../../../graphql";
import SpeakerBarSegmentV2 from "./SpeakerBarSegmentV2";

type SpeakerBarV2Props = {
  callDuration: number;
  candidateOnly?: boolean;
  speaker: CallSpeakerFragment;
  segments: TranscriptSegmentFragment[];
  onClickSegment: (startTime: number) => void;
} & Omit<FlexProps, "children">;

const SpeakerBarV2: React.FC<SpeakerBarV2Props> = ({
  callDuration,
  candidateOnly = false,
  speaker,
  segments,
  onClickSegment,
  ...rest
}) => {
  return (
    <Flex
      position="relative"
      alignItems="center"
      bg="whiteAlpha.200"
      borderRadius="4px"
      h="16px"
      p="6px"
      mt={2}
      w="100%"
      {...rest}
    >
      {segments.map((segment) => (
        <SpeakerBarSegmentV2
          candidateOnly={candidateOnly}
          key={segment.id}
          speaker={speaker}
          segment={segment}
          callDuration={callDuration}
          onClickSegment={onClickSegment}
        />
      ))}
    </Flex>
  );
};

export default SpeakerBarV2;
